// Shared by the cart add-ons (gift wrap, discount code): post a change to the cart, then redraw
// every part of the page that shows the cart from Shopify's own section HTML.
window.scCart = window.scCart || {
  targets() {
    const list = [{ section: 'cart-icon-bubble', target: document.getElementById('cart-icon-bubble'), from: '.shopify-section' }];
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    if (items) list.push({ section: items.dataset.id, target: items.querySelector('.js-contents'), from: '.js-contents' });
    if (footer) {
      list.push({ section: footer.dataset.id, target: footer.querySelector('.js-contents'), from: '.js-contents' });
      list.push({ section: footer.dataset.id, target: document.getElementById('ScCartAddons'), from: '#ScCartAddons' });
    }
    const drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (drawer) list.push({ section: 'cart-drawer', target: drawer, from: '.drawer__inner' });
    return list.filter((t) => t.section && t.target);
  },

  async update(path, body) {
    const targets = this.targets();
    const sections = [...new Set(targets.map((t) => t.section))];
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/${path}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Error');

    targets.forEach(({ section, target, from }) => {
      const html = data.sections?.[section];
      if (!html) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(from);
      if (source) target.innerHTML = source.innerHTML;
    });
    return data;
  },
};

if (!customElements.get('sc-cart-discount')) {
  customElements.define(
    'sc-cart-discount',
    class ScCartDiscount extends HTMLElement {
      // Listeners sit on the element itself, so they survive its contents being redrawn.
      connectedCallback() {
        this.addEventListener('submit', (event) => {
          event.preventDefault();
          const code = this.querySelector('input').value.trim();
          if (code) this.apply([...this.codes(), code]);
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sc-remove]');
          if (button) this.apply(this.codes().filter((c) => c !== button.dataset.scRemove));
        });
        this.list();
      }

      // The codes on the cart, each with a remove button and a note when it does not apply.
      async list() {
        const root = window.Shopify?.routes?.root || '/';
        const cart = await (await fetch(`${root}cart.js`)).json();
        const list = this.querySelector('.sc-discount__codes');
        list.replaceChildren(
          ...cart.discount_codes.map(({ code, applicable }) => {
            const item = document.createElement('li');
            item.className = `sc-discount__code${applicable ? '' : ' is-invalid'}`;
            item.innerHTML = `<span></span><button type="button" class="sc-discount__remove">${this.querySelector('.sc-discount__icon').innerHTML}</button>`;
            item.querySelector('span').textContent = code;
            const button = item.querySelector('button');
            button.dataset.scRemove = code;
            button.setAttribute('aria-label', window.scStrings.discountRemove.replace('[code]', code));
            if (!applicable) {
              const note = document.createElement('span');
              note.className = 'sc-discount__note';
              note.textContent = window.scStrings.discountInvalid;
              item.append(note);
            }
            return item;
          })
        );
        list.hidden = !cart.discount_codes.length;
        if (cart.discount_codes.length) this.querySelector('details').open = true;
      }

      codes() {
        return [...this.querySelectorAll('[data-sc-remove]')].map((b) => b.dataset.scRemove);
      }

      async apply(codes) {
        this.setAttribute('aria-busy', 'true');
        const error = this.querySelector('.sc-discount__error');
        error.hidden = true;
        try {
          await window.scCart.update('update', { discount: [...new Set(codes)].join(',') });
        } catch (e) {
          error.textContent = e.message;
          error.hidden = false;
        } finally {
          this.removeAttribute('aria-busy');
        }
      }
    }
  );
}
